import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { X, Cookie, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

export const CookieConsent = () => {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user already accepted cookies
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after 1 second
      setTimeout(() => setShow(true), 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShow(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShow(false);
  };

  if (!show) return null;
  const lang = i18n.language || 'en';

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t-2 border-amber-600 shadow-2xl animate-in slide-in-from-bottom duration-500" data-testid="cookie-consent-banner">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          {/* Icon */}
          <div className="flex-shrink-0">
            <Cookie className="w-10 h-10 text-amber-600" />
          </div>

          {/* Content */}
          <div className="flex-1">
            <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
              <CheckCircle className="w-5 h-5 text-green-600 mr-2" />
              {t('cookies.title')}
            </h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              {t('cookies.description')}
              {' '}
              <Link to={`/${lang}/privacy`} className="text-amber-600 hover:underline font-medium">
                {t('cookies.privacy_link')}
              </Link>
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <Button
              onClick={acceptCookies}
              className="bg-amber-600 hover:bg-amber-700 text-white"
              data-testid="cookie-accept-btn"
            >
              {t('cookies.accept')}
            </Button>
            <Button
              onClick={rejectCookies}
              variant="outline"
              className="border-gray-300"
              data-testid="cookie-reject-btn"
            >
              {t('cookies.reject')}
            </Button>
          </div>

          {/* Close button */}
          <button
            onClick={rejectCookies}
            className="absolute top-4 right-4 md:relative md:top-0 md:right-0 text-gray-400 hover:text-gray-600"
            aria-label={t('cookies.close')}
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};
